// extracted by mini-css-extract-plugin
module.exports = {"content":"_1xo3kh7bMdQ0O1dvvRiQGY"};